import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import AnimalSymbol from "@/components/AnimalSymbol";
import { useAuth } from "@/contexts/AuthContext";
import { SUBSCRIBE_URL } from "@/lib/config";

export default function TrialExpiredPage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  // Defensive: if the user has access, bounce them home.
  if (user && user.has_access) {
    setTimeout(() => nav("/", { replace: true }), 0);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--app-bg)] p-6">
      <div className="w-full max-w-md bg-white border border-[var(--app-border)] rounded-lg p-8 shadow-sm text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-md bg-[var(--app-bg)] border border-[var(--app-border)] flex items-center justify-center">
          <AnimalSymbol parts={{ ears: "correct", head: "correct", neck: "correct", front: "correct", back: "correct", rear: "correct", tail: "correct" }} size={36} />
        </div>
        <div className="font-display font-extrabold text-2xl mb-2 tracking-tight">Your free trial has ended</div>
        <p className="text-sm text-[var(--app-text-soft)] mb-6 leading-relaxed">
          Subscribe to keep recording, analysing and printing your pedigrees.
          All your data is safe — sign in any time after subscribing and pick up where you left off.
        </p>
        <a href={SUBSCRIBE_URL} target="_blank" rel="noopener noreferrer">
          <Button className="w-full bg-blue-600 hover:bg-blue-700" data-testid="subscribe-button">
            Subscribe — $8 / month
          </Button>
        </a>
        <div className="mt-4 flex items-center justify-center gap-4 text-xs text-[var(--app-text-soft)]">
          <button onClick={logout} className="hover:text-[var(--app-text)] hover:underline" data-testid="logout-link">
            Sign out
          </button>
          <span>·</span>
          <Link to="/" className="hover:text-[var(--app-text)] hover:underline">View read-only library</Link>
        </div>
      </div>
    </div>
  );
}
